const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/triemli/eCheckin/sections/fields/ZusatzversicherungField.tsx';
import { generateMetaKatDropDownField } from 'App/components/eCheckin/generateMetaKatDropDownField';

export const ZusatzversicherungField = generateMetaKatDropDownField(
    '62a6b84c-40bb-4e2b-829e-ecf490408455',
    'ZusatzversicherungField'
);

export default ZusatzversicherungField;
